// src/components/LocationMap/LocationMap.js
import React from 'react';
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import './LocationMap.css'; // Import styles

const mapContainerStyle = {
  width: '100%',
  height: '300px',
};

const center = {
  lat: 1.3573, // Replace with your factory's latitude
  lng: 103.8480, // Replace with your factory's longitude
};

const LocationMap = () => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: 'AIzaSyDd01peZtJnxtxIi-ORf3HqwZm6-TnIiOA', // Replace with your API key
  });

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <div className="location-card">
      {/* Map Section */}
      <div className="map-container">
        <h2>Find Us Here!</h2>
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          zoom={15} // Adjust the zoom level
          center={center}
        >
          <Marker position={center} />
        </GoogleMap>
      </div>

      {/* Contact Information Section */}
      <div className="contact-info">
        <h2>Contact Information</h2>
        <p><strong>📍 Address:</strong><br /> Blk 213 Bishan Street 23 Singapore 570213</p>
        <p><strong>📞 Phone:</strong><br /> 96366354</p>
        <p><strong>✉ Email:</strong><br /> kozeehome1@gmail.com</p>
      </div>
    </div>
  );
};

export default LocationMap;
